import { rootNamespace } from "config";
import { TreeContext } from "pages/Editor/Editor";
import { forwardRef, useContext, useEffect } from "react";

function RefBroadcaster({ path }, ref) {
  const { subscribe, publish } = useContext(TreeContext);
  useEffect(() => {
    return subscribe(rootNamespace, "SELECT", (_path) => {
      if (_path === path) {
        publish(rootNamespace, "PROPS", { ref: ref.current, path: _path });
      }
    });
  }, [path, publish, ref, subscribe]);
  return null;
}

export default forwardRef(RefBroadcaster);
